import { CSSProperties, FC, ReactNode } from "react";
import cs from "classnames";
import styles from "./styles.module.scss";

export type EColors =
  | "blueLight"
  | "primary"
  | "error"
  | "gray"
  | "indigo"
  | "success"
  | "warning"
  | "transparent";

interface IProps {
  className?: string;
  color?: EColors;
  icon?: ReactNode;
  label: ReactNode;
  size?: "sm" | "md" | "lg";
  style?: CSSProperties | undefined;
}

const Badge: FC<IProps> = ({
  className = "",
  color = "primary",
  icon,
  label,
  size = "md",
  style
}) => (
  <div
    style={style}
    className={cs(styles.badge, styles[color], styles[size], className, {
      [styles.hasIcon]: !!icon,
    })}
  >
    {icon}
    {label}
  </div>
);

export default Badge;
